import {NgModule, Component, OnInit, OnDestroy, Input} from '@angular/core';
import { SocketService } from '../../services/socket.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UserInfoModule } from '../../components/userInfo';
import { HttpService } from '../../services/http.service';
import { EventService } from '../../services/event.service';
import { SharedPipeChatModule } from '../../shared/shared.pipe.chat.module';
import { ObjToArrayPipeModule } from '../../pipes/objtoarray.pipe';

@Component({
    selector: 'chance-talk-list',
    template: `
    <div class="chat_box">
        <div class="chat_chance_list scroll" [ngStyle]="{height: (dynamicHeight) + 'px'}" >
            <ul>
                <!-- <li *ngFor="let (k, v) of setData.lists">-->
                <li *ngFor="let list of setData.lists | objtoarray">
                    <div class="expired" *ngIf="list.v.data.room_expired|dataCompare">
                        <span class="txt">유효기간이 지난 대화목록입니다.<br>대화재개시 찬스톡 사용권이 1회 감소됩니다.</span>
                        <span class="button-box">
                            <button type="button" class="re-chancetalk" (click)="re_chancetalk_view(list.k)">대화재개</button>
                            <button type="button" class="preview-chancetalk" (click)="preview_chancetalk_view(list.k)">지난대화보기</button>
                            <button type="button" class="leave-chancetalk" (click)="leave_chancetalk_view(list.k)">삭제</button>
                        </span>
                    </div>

                    <p *ngIf="list.v.data.room_type === 'P'" (click)="chancetalkView(list.k)">
                        <user-info [mbid]="list.v.data.mb_id">
                            <img [alt]="list.v.data.mb_id" appIsProfileimg class="profileImgS4">
                        </user-info>
                        <span><em><img [src]="'assets/images/common/lv/' + list.v.data.mb_level + '.png'" alt="" class="lvS1">
                            {{list.v.data.mb_nick}}</em><span>
                            {{list.v.data.created | transferChancetalk}}</span></span>
                        <em class="date">{{list.v.data.msg}}</em>
                    </p>
                    <p *ngIf="list.v.data.room_type === 'G'" (click)="chancetalkView(list.k)">
                        <img src="assets/images/chat-group.png"  alt="" class="profileImgS4">
                        <span><em>{{list.v.data.mb_nick | chancetalkGroupName :list.v.participants}}</em>
                        <span>{{list.v.data.created | transferChancetalk}}</span></span>
                        <em class="date">{{list.v.data.msg}}</em>
                    </p>
                </li>
            </ul>
        </div><!--chat_list scroll -->
    </div><!-- // chat_box -->
`
})
export class ChanceTalkListComponent implements OnInit, OnDestroy {

    dynamicHeight = 300;
    sockConnection = new Array();
    setData: any = {lists: {}};
    // private subscription: Subscription; // 채팅창 관련 다양한 이벤트를 이곳에서 받는다.

    @Input() set resizeObject(resizeData: {edges: any, rectangle: any }) {
        if (!resizeData.rectangle) {
            return;
        }
        this.dynamicHeight = resizeData.rectangle.height - 78;
    }

    @Input() set selectedChatIndex(index: number) {
        if (index === 1) {
            this.socketService.Emit('leave_curent_room', '@basic1');
            this.socketService.removeListener('publicChat'); // 공개채팅방과 연결된 리스너 삭제
            this.socketService.removeListener('chanceTalkView'); // 찬스톡 상세보기 관련 리스너 삭제
            // 공개 채팅방이면
            this.get_chancetalker();
        }
    }

    constructor(
        private socketService: SocketService,
        private http: HttpService,
        private eventService: EventService,
        // private toasterService: ToasterService
    ) {

    }
    // private chatService: ChatService,

    ngOnInit() {
        // console.log('ngOnInit');
    }

    ngOnDestroy() {
        // console.log('ngOnDestroy');
    }

    private get_chancetalker() {
        this.http.get({url: 'chat/get-chancetalkers'}).then((obj) => {
            this.setData.lists = obj.chat_list;
        });
    }

    /**
     * 찬스톡 대화창으로 이동
     * 현재 찬스톡 방 정보를 세팅한다.
     */
    chancetalkView(chatId: string) {
        this.send({type: 'chanceTalkView', chat_id: chatId, view_mode: 'chancetalk'});
    }

    // 찬스톡 대화 재개 하기
    re_chancetalk_view(chatId: string) {
        this.send({type: 'chanceTalkView', chat_id: chatId, view_mode: 'reOpen'});
    }

    // 지난대화보기 (대화입력은 불가능하고 단지 지난 대화만을 볼 수 있는 시스템)
    preview_chancetalk_view(chatId: string) { // view_mode    = 'normal'; // preview(지난대화보기)
        this.send({type: 'chanceTalkView', chat_id: chatId, view_mode: 'preview'});
    }

    // 현재 대화내용 삭제
    leave_chancetalk_view(chatId: string) {
        const paramObj = {chancetalk_room_id: chatId};

        this.http.post({url: 'chat/leave-chancetalk-room', params: paramObj}).then(() => {
            this.get_chancetalker();
        });
    }

    private send(obj: any) {
        this.eventService.broadcast('chancetalk', obj);
    }
/*
    private subscribe() {
        // this.subscription =
        this.eventService.subscribe('chancetalk', () => {}); // (payload)
    }
    */
}

@NgModule({
    declarations: [
        ChanceTalkListComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        SharedPipeChatModule,
        UserInfoModule,
        ObjToArrayPipeModule
    ],
    exports: [
        ChanceTalkListComponent
    ]
})
export class ChanceTalkListModule {}
